/**
 * Exposes Rails-injected global constants and locale utilities.
 * Globals are written to window.* before Vue mounts via #global-variables div.
 */
export function useConstants() {
  const APPLICATION_NAME = window.APPLICATION_NAME
  const APPLICATION_DOMAIN = window.APPLICATION_DOMAIN
  const APPLICATION_URL = window.APPLICATION_URL
  const IS_TIMELYDO_PRODUCTION = window.IS_TIMELYDO_PRODUCTION
  const I18N = JSON.parse(window.I18N)
  const CURRENT_LOCALE = window.CURRENT_LOCALE
  const UI_LOCALE_NAME = window.UI_LOCALE_NAME

  function parseLocale(locale, dataObject) {
    let formatted = locale
    try {
      for (const key in dataObject) {
        const regex = new RegExp(`%{${key}}`, 'g')
        formatted = formatted.replace(regex, dataObject[key])
      }
    } catch (error) {
      console.log(error)
    }
    return formatted
  }

  return {
    APPLICATION_NAME,
    APPLICATION_DOMAIN,
    APPLICATION_URL,
    IS_TIMELYDO_PRODUCTION,
    I18N,
    CURRENT_LOCALE,
    UI_LOCALE_NAME,
    parseLocale,
  }
}
